import React from "react";
import { number, bool, string } from "prop-types";

import Icon from "../icon";

const Facebook = ({ width = 28, height = 28, isShareRequired, text }) => (
  <Icon type="facebook" isShareRequired={isShareRequired} text={text}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28">
      <g transform="translate(-517 -1010)">
        <path d="M0 0h28v28H0z" fill="rgba(255,255,255,0)" transform="translate(517 1010)" />
        <g transform="translate(521.34 1014.341)">
          <path
            d="M19.281 9.641a9.64 9.64 0 1 0-11.147 9.523v-6.737H5.686V9.641h2.448V7.517a3.4 3.4 0 0 1 3.641-3.751 14.824 14.824 0 0 1 2.158.188v2.373h-1.215a1.393 1.393 0 0 0-1.571 1.506v1.808h2.673l-.427 2.787h-2.246v6.737a9.643 9.643 0 0 0 8.134-9.524z"
            fill="#fff"
          />
          <path
            d="M309.665 208.615l.425-2.772h-2.659v-1.8a1.386 1.386 0 0 1 1.563-1.5h1.206v-2.36a14.742 14.742 0 0 0-2.146-.187 3.384 3.384 0 0 0-3.622 3.731v2.112H302v2.772h2.435v6.7a9.689 9.689 0 0 0 3 0v-6.7z"
            fill="#1877f2"
            transform="translate(-296.291 -196.151)"
          />
        </g>
      </g>
    </svg>
  </Icon>
);

Facebook.propTypes = {
  width: number,
  height: number,
  isShareRequired: bool,
  text: string,
};

export default Facebook;
